<script setup lang="ts">

import {watch} from "vue";

const model = defineModel<string | null>()

defineProps<{
    id: string,
    label?: string,
    disabled?: boolean,
    required?: boolean,
    rows: number,
    error?: string,
}>()

const emit = defineEmits(['clearError'])

watch(model, () => emit('clearError'))

</script>

<template>
    <div class="space-y-4">
        <label class="w-full" :for="id">
            {{ label }}<span v-if="required" class="text-primary ml-2">*</span>
        </label>

        <div class="relative flex items-center border border-solid rounded duration-150 hover:bg-gray-accent group"
             :class="error ? 'border-primary' : 'border-gray-light'"
        >
            <textarea :id="id" v-model="model" :rows="rows" :disabled="disabled"
                      class="border-none rounded w-full p-4 text-sm text-dark grow duration-150 outline-none focus:outline-none hover:bg-gray-accent"
                      :class="disabled ? 'bg-gray-accent' : 'bg-white'">
            </textarea>
        </div>

        <div v-if="error" class="text-xs text-primary mt-2">{{ error }}</div>
    </div>
</template>
